import { HttpClient } from '@angular/common/http';

import { AppConfigSettings } from '@arc/arc-shared-frontend';
import { Observable, of } from 'rxjs';
import {
  CreatePaymentAccountRequestV1,
  CreatePaymentAccountResponseV1,
  GetAllPaymentAccountsResponseV1,
} from '../models';
import { PaymentAccountsService } from './payment-accounts.service';

export class PaymentAccountsGuestCheckoutService extends PaymentAccountsService {
  protected baseUrl: string;

  constructor(
    private httpClient: HttpClient,
    protected appConfig: AppConfigSettings,
  ) {
    super(appConfig);
  }

  createPaymentAccountV1(
    tenantId: string,
    createAccountRequest: CreatePaymentAccountRequestV1,
    sendNotifications: boolean = false,
  ): Observable<CreatePaymentAccountResponseV1> {
    let url = `${this.baseUrl}/v1/tenants/${tenantId}/hosted-payments-page-associated-payment-accounts`;
    if (sendNotifications) {
      url = url + `?sendNotifications=${sendNotifications}`;
    }

    return this.httpClient.post<CreatePaymentAccountResponseV1>(
      url,
      createAccountRequest,
    );
  }

  deletePaymentAccount(): Observable<void> {
    return of();
  }

  getAllPaymentAccountsV1(): Observable<GetAllPaymentAccountsResponseV1> {
    return of({
      paymentAccounts: [],
    });
  }

  getAllPaymentAccountsV1ByUsers(): Observable<GetAllPaymentAccountsResponseV1> {
    return of({
      paymentAccounts: [],
    });
  }

  updateExpirationDateV1(): Observable<void> {
    return of();
  }
}
